<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="M2 17.1q0 1 .7 1.7.8.6 1.8.7h15q1 0 1.8-.7.6-.6.7-1.7v-6.5H2zM5 14q0-.6.3-1 .4-.3 1-.3h2.1q.6 0 1 .4.3.3.4.9v.8q0 .6-.4 1-.4.3-1 .3H6.3q-.6 0-1-.4-.4-.3-.4-.9zm14.5-9.4h-15q-1 0-1.8.7-.6.6-.7 1.7v1h20V7q0-1-.7-1.7t-1.8-.7"
    />
  </svg>
</template>
